module.exports = __webpack_public_path__ + "Icono_Lumbar-Ngr_126px.png";